export enum UrlMatching {
  fullMatch = 'fullMatch',
  wildcard = 'wildcard'
}
